import React from "react"
import { useCallback, useState } from "react"
import useAuth from "./useAuth.hook"


export const useHttp = () => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const auth = useAuth()

    const request = useCallback(async (url, method = 'GET', body = null, headers = {}) => {
        setLoading(true)
        try {
            if (body) {
                body = JSON.stringify(body)
                headers['Content-Type'] = 'application/json'
            }
            if (!!auth.token) {
                headers['x-access-token'] = auth.token
            }
            
            const respons = await fetch(url, { method, body, headers })
            const data = await respons.json()

            if (!respons.ok)
                throw new Error(data.message || 'Error')

            setLoading(false)
            return data
        } catch (e) {
            setLoading(false)
            setError(e.message)
            throw e
        }
    }, [])

    const clearError = () => setError(null)
    return {
        loading, request, error, clearError
    }
}